const privacyPolicyBlocksId = [
  {
    "type": "heading",
    "text": "Kebijakan Privasi"
  },
  {
    "type": "paragraph",
    "text": "Diperbarui pada 2026-03-02"
  },
  {
    "type": "paragraph",
    "text": "Saat Teduh (\"kami\", \"milik kami\", atau \"kita\") berkomitmen untuk melindungi privasi Anda. Kebijakan Privasi ini menjelaskan bagaimana informasi pribadi Anda dikumpulkan, digunakan, dan diungkapkan oleh Saat Teduh."
  },
  {
    "type": "paragraph",
    "text": "Kebijakan Privasi ini berlaku untuk website kami, beserta subdomain terkait (secara kolektif disebut \"Layanan\"), bersama dengan aplikasi kami, Saat Teduh. Dengan mengakses atau menggunakan Layanan kami, Anda menyatakan bahwa Anda telah membaca, memahami, dan menyetujui pengumpulan, penyimpanan, penggunaan, dan pengungkapan informasi pribadi Anda sebagaimana dijelaskan dalam Kebijakan Privasi ini dan Ketentuan Layanan kami. Kebijakan Privasi ini dibuat dengan Termify ."
  },
  {
    "type": "heading",
    "text": "Definisi dan istilah kunci"
  },
  {
    "type": "paragraph",
    "text": "Untuk membantu menjelaskan hal-hal sejelas mungkin dalam Kebijakan Privasi ini, setiap kali istilah-istilah berikut disebutkan, istilah tersebut didefinisikan secara ketat sebagai berikut:"
  },
  {
    "type": "list",
    "items": [
      "Cookie: sejumlah kecil data yang dihasilkan oleh website dan disimpan oleh browser web Anda. Cookie digunakan untuk mengidentifikasi browser Anda, menyediakan analitik, dan mengingat informasi tentang Anda seperti preferensi bahasa atau informasi login.",
      "Company: ketika kebijakan ini menyebut \"Perusahaan\", \"kami\", \"milik kami\", atau \"kita\", yang dimaksud adalah Saat Teduh, yang bertanggung jawab atas informasi Anda berdasarkan Kebijakan Privasi ini.",
      "Country: tempat Saat Teduh atau pemilik/pendiri Saat Teduh berbasis, dalam hal ini adalah Indonesia",
      "Customer: merujuk pada perusahaan, organisasi, atau orang yang mendaftar untuk menggunakan Layanan Saat Teduh guna mengelola hubungan dengan konsumen atau pengguna layanannya.",
      "Device: perangkat apa pun yang terhubung ke internet seperti ponsel, tablet, komputer, atau perangkat lain yang dapat digunakan untuk mengunjungi Saat Teduh dan menggunakan layanan.",
      "IP address: setiap perangkat yang terhubung ke Internet diberi nomor yang dikenal sebagai alamat Internet protocol (IP). Nomor-nomor ini biasanya ditetapkan dalam blok geografis. Alamat IP sering kali dapat digunakan untuk mengidentifikasi lokasi asal perangkat terhubung ke Internet.",
      "Personnel: merujuk pada individu yang dipekerjakan oleh Saat Teduh atau berada di bawah kontrak untuk melakukan layanan atas nama salah satu pihak.",
      "Personal Data: informasi apa pun yang secara langsung, tidak langsung, atau terkait dengan informasi lain - termasuk nomor identifikasi pribadi - memungkinkan identifikasi atau dapat diidentifikasinya seseorang.",
      "Service: merujuk pada layanan yang disediakan oleh Saat Teduh sebagaimana dijelaskan dalam ketentuan terkait (jika tersedia) dan pada platform ini.",
      "Third-party service: merujuk pada pengiklan, sponsor kontes, mitra promosi dan pemasaran, serta pihak lain yang menyediakan konten kami atau yang produk/jasanya kami anggap mungkin menarik bagi Anda.",
      "Website: situs milik Saat Teduh, yang dapat diakses melalui URL ini:",
      "You: orang atau entitas yang terdaftar di Saat Teduh untuk menggunakan Layanan."
    ]
  },
  {
    "type": "heading",
    "text": "Informasi yang dikumpulkan secara otomatis"
  },
  {
    "type": "paragraph",
    "text": "Ada beberapa informasi seperti alamat Internet Protocol (IP) Anda dan/atau karakteristik browser serta perangkat - yang dikumpulkan secara otomatis ketika Anda mengunjungi platform kami. Informasi ini dapat digunakan untuk menghubungkan komputer Anda ke Internet. Informasi lain yang dikumpulkan secara otomatis dapat berupa login, alamat email, kata sandi, informasi komputer dan koneksi seperti jenis serta versi plug-in browser dan pengaturan zona waktu, sistem operasi dan platform, riwayat pembelian, (kadang kami gabungkan dengan informasi serupa dari Pengguna lain), clickstream penuh Uniform Resource Locator (URL) ke, melalui, dan dari Website kami yang dapat mencakup tanggal dan waktu; nomor cookie; bagian situs yang Anda lihat atau cari; dan nomor telepon yang Anda gunakan untuk menghubungi Layanan Pelanggan kami. Kami juga dapat menggunakan data browser seperti cookie, Flash cookie (juga dikenal sebagai Flash Local Shared Objects) atau data serupa di bagian tertentu Website kami untuk pencegahan penipuan dan tujuan lainnya. Selama kunjungan Anda, kami dapat menggunakan perangkat lunak seperti JavaScript untuk mengukur dan mengumpulkan informasi sesi termasuk waktu respons halaman, error unduhan, lama kunjungan pada halaman tertentu, informasi interaksi halaman (seperti scrolling, klik, dan mouse-over), serta metode yang digunakan untuk keluar dari halaman. Kami juga dapat mengumpulkan informasi teknis untuk membantu kami mengidentifikasi perangkat Anda demi pencegahan penipuan dan tujuan diagnostik."
  },
  {
    "type": "paragraph",
    "text": "Kami secara otomatis mengumpulkan informasi tertentu ketika Anda mengunjungi, menggunakan, atau menavigasi platform. Informasi ini tidak mengungkap identitas spesifik Anda (seperti nama atau informasi kontak), tetapi dapat mencakup informasi perangkat dan penggunaan, seperti alamat IP, karakteristik browser dan perangkat, sistem operasi, preferensi bahasa, URL rujukan, nama perangkat, negara, lokasi, informasi tentang siapa dan kapan Anda menggunakan kami, serta informasi teknis lainnya. Informasi ini terutama diperlukan untuk menjaga keamanan dan operasional platform kami, serta untuk tujuan analitik dan pelaporan internal kami."
  },
  {
    "type": "heading",
    "text": "Layanan AI Pihak Ketiga"
  },
  {
    "type": "paragraph",
    "text": "Kami menggunakan layanan AI pihak ketiga untuk memberikan fitur chat, pembuatan gambar, dan text-to-speech. Penyedia kami saat ini meliputi OpenAI (chat dan pembuatan gambar) dan ElevenLabs (text-to-speech)."
  },
  {
    "type": "paragraph",
    "text": "Saat Anda menggunakan fitur ini, kami mengirim konten yang Anda berikan (mis. pesan, prompt, atau teks untuk audio), pengaturan yang dipilih (bahasa, tone, suara), serta identifier teknis terbatas (device ID, RevenueCat app user ID, dan token Firebase App Check) ke server kami lalu ke penyedia AI untuk memproses permintaan Anda."
  },
  {
    "type": "paragraph",
    "text": "Kami meminta izin sebelum mengirim data ke penyedia tersebut. Jika Anda tidak setuju, fitur AI akan dinonaktifkan. Hindari mengirim data pribadi sensitif."
  },
  {
    "type": "heading",
    "text": "Penjualan Bisnis"
  },
  {
    "type": "paragraph",
    "text": "Kami berhak untuk mengalihkan informasi kepada pihak ketiga apabila terjadi penjualan, merger, atau pengalihan lain atas seluruh atau secara substansial seluruh aset Saat Teduh atau afiliasi korporasinya (sebagaimana didefinisikan di sini), atau bagian dari Saat Teduh atau afiliasi korporasinya yang terkait dengan Layanan, atau apabila kami menghentikan bisnis kami atau mengajukan petisi atau ada petisi terhadap kami dalam kepailitan, reorganisasi, atau proses serupa, dengan ketentuan pihak ketiga tersebut setuju untuk mematuhi ketentuan Kebijakan Privasi ini."
  },
  {
    "type": "heading",
    "text": "Afiliasi"
  },
  {
    "type": "paragraph",
    "text": "Kami dapat mengungkapkan informasi (termasuk informasi pribadi) tentang Anda kepada Afiliasi Korporasi kami. Untuk tujuan Kebijakan Privasi ini, \"Afiliasi Korporasi\" berarti setiap orang atau entitas yang secara langsung maupun tidak langsung mengendalikan, dikendalikan oleh, atau berada di bawah kendali bersama dengan Saat Teduh, baik melalui kepemilikan maupun cara lain. Setiap informasi terkait Anda yang kami berikan kepada Afiliasi Korporasi kami akan diperlakukan oleh Afiliasi Korporasi tersebut sesuai dengan ketentuan Kebijakan Privasi ini."
  },
  {
    "type": "heading",
    "text": "Hukum yang Mengatur"
  },
  {
    "type": "paragraph",
    "text": "Kebijakan Privasi ini diatur oleh hukum Indonesia tanpa memperhatikan ketentuan pertentangan hukumnya. Anda menyetujui yurisdiksi eksklusif pengadilan sehubungan dengan setiap tindakan atau sengketa yang timbul antara para pihak berdasarkan atau terkait dengan Kebijakan Privasi ini, kecuali bagi individu yang mungkin memiliki hak untuk mengajukan klaim berdasarkan Privacy Shield, atau kerangka Swiss-US."
  },
  {
    "type": "paragraph",
    "text": "Hukum Indonesia, tidak termasuk aturan pertentangan hukumnya, akan mengatur Perjanjian ini dan penggunaan aplikasi oleh Anda. Penggunaan aplikasi oleh Anda juga dapat tunduk pada hukum lokal, negara bagian, nasional, atau internasional lainnya."
  },
  {
    "type": "paragraph",
    "text": "Dengan menggunakan Saat Teduh atau menghubungi kami secara langsung, Anda menyatakan penerimaan Anda terhadap Kebijakan Privasi ini. Jika Anda tidak setuju dengan Kebijakan Privasi ini, Anda tidak boleh berinteraksi dengan website kami, atau menggunakan layanan kami. Penggunaan berkelanjutan atas website, interaksi langsung dengan kami, atau setelah dipublikasikannya perubahan pada Kebijakan Privasi ini yang tidak secara signifikan memengaruhi penggunaan atau pengungkapan informasi pribadi Anda akan berarti bahwa Anda menerima perubahan tersebut."
  },
  {
    "type": "heading",
    "text": "Persetujuan Anda"
  },
  {
    "type": "paragraph",
    "text": "Kami telah memperbarui Kebijakan Privasi kami untuk memberikan transparansi penuh kepada Anda tentang apa yang ditetapkan saat Anda mengunjungi situs kami dan bagaimana hal itu digunakan. Dengan menggunakan aplikasi kami, mendaftarkan akun, atau melakukan pembelian, Anda dengan ini menyetujui Kebijakan Privasi kami dan setuju pada ketentuannya."
  },
  {
    "type": "heading",
    "text": "Tautan ke Website Lain"
  },
  {
    "type": "paragraph",
    "text": "Kebijakan Privasi ini hanya berlaku untuk Layanan. Layanan dapat berisi tautan ke website lain yang tidak dioperasikan atau dikendalikan oleh Saat Teduh. Kami tidak bertanggung jawab atas konten, akurasi, atau pendapat yang dinyatakan pada website tersebut, dan website tersebut tidak diselidiki, dipantau, atau diperiksa akurasi maupun kelengkapannya oleh kami. Harap diingat bahwa ketika Anda menggunakan tautan untuk berpindah dari Layanan ke website lain, Kebijakan Privasi kami tidak lagi berlaku. Aktivitas penelusuran dan interaksi Anda pada website lain mana pun, termasuk yang memiliki tautan di platform kami, tunduk pada aturan dan kebijakan website tersebut. Pihak ketiga tersebut dapat menggunakan cookie mereka sendiri atau metode lain untuk mengumpulkan informasi tentang Anda."
  },
  {
    "type": "heading",
    "text": "Cookie"
  },
  {
    "type": "paragraph",
    "text": "Saat Teduh menggunakan \"Cookies\" untuk mengidentifikasi area website kami yang Anda kunjungi. Cookie adalah data kecil yang disimpan di komputer atau perangkat seluler Anda oleh browser web. Kami menggunakan Cookies untuk meningkatkan performa dan fungsionalitas aplikasi kami tetapi tidak esensial bagi penggunaannya. Namun, tanpa cookies ini, fungsi tertentu seperti video dapat menjadi tidak tersedia atau Anda mungkin diminta memasukkan detail login setiap kali mengunjungi aplikasi karena kami tidak dapat mengingat bahwa Anda telah login sebelumnya. Sebagian besar browser web dapat diatur untuk menonaktifkan penggunaan Cookies. Namun, jika Anda menonaktifkan Cookies, Anda mungkin tidak dapat mengakses fungsi pada website kami secara benar atau sama sekali. Kami tidak pernah menempatkan Informasi Identitas Pribadi dalam Cookies."
  },
  {
    "type": "heading",
    "text": "Memblokir dan menonaktifkan cookie serta teknologi serupa"
  },
  {
    "type": "paragraph",
    "text": "Di mana pun Anda berada, Anda juga dapat mengatur browser untuk memblokir cookie dan teknologi serupa, tetapi tindakan ini dapat memblokir cookie esensial kami dan mencegah website kami berfungsi dengan benar, dan Anda mungkin tidak dapat memanfaatkan seluruh fitur serta layanannya. Anda juga perlu memahami bahwa Anda mungkin kehilangan beberapa informasi tersimpan (misalnya detail login tersimpan, preferensi situs) jika memblokir cookie pada browser Anda. Browser yang berbeda menyediakan kontrol yang berbeda. Menonaktifkan suatu cookie atau kategori cookie tidak menghapus cookie tersebut dari browser Anda, Anda perlu melakukannya sendiri dari dalam browser, Anda sebaiknya mengunjungi menu bantuan browser Anda untuk informasi lebih lanjut."
  },
  {
    "type": "heading",
    "text": "Detail Pembayaran"
  },
  {
    "type": "paragraph",
    "text": "Sehubungan dengan detail kartu kredit atau detail pemrosesan pembayaran lain yang Anda berikan kepada kami, kami berkomitmen bahwa informasi rahasia ini akan disimpan dengan cara yang paling aman."
  },
  {
    "type": "heading",
    "text": "Privasi Anak"
  },
  {
    "type": "paragraph",
    "text": "Kami mengumpulkan informasi dari anak di bawah usia 13 tahun hanya untuk meningkatkan layanan kami. Jika Anda adalah orang tua atau wali dan Anda mengetahui bahwa anak Anda telah memberikan Data Pribadi kepada Kami tanpa izin Anda, silakan hubungi Kami. Jika Kami mengetahui bahwa Kami telah mengumpulkan Data Pribadi dari siapa pun di bawah usia 13 tahun tanpa verifikasi persetujuan orang tua, Kami mengambil langkah untuk menghapus informasi tersebut dari server Kami."
  },
  {
    "type": "heading",
    "text": "Perubahan pada Kebijakan Privasi Kami"
  },
  {
    "type": "paragraph",
    "text": "Kami dapat mengubah Layanan dan kebijakan kami, dan kami mungkin perlu melakukan perubahan pada Kebijakan Privasi ini agar secara akurat mencerminkan Layanan dan kebijakan kami. Kecuali diwajibkan lain oleh hukum, kami akan memberi tahu Anda (misalnya melalui Layanan kami) sebelum kami membuat perubahan pada Kebijakan Privasi ini dan memberi Anda kesempatan untuk meninjaunya sebelum berlaku. Kemudian, jika Anda terus menggunakan Layanan, Anda akan terikat oleh Kebijakan Privasi yang diperbarui. Jika Anda tidak ingin menyetujui ini atau Kebijakan Privasi yang diperbarui, Anda dapat menghapus akun Anda."
  },
  {
    "type": "heading",
    "text": "Layanan Pihak Ketiga"
  },
  {
    "type": "paragraph",
    "text": "Kami dapat menampilkan, menyertakan, atau menyediakan konten pihak ketiga (termasuk data, informasi, aplikasi, dan produk layanan lainnya) atau menyediakan tautan ke website atau layanan pihak ketiga (\"Layanan Pihak Ketiga\")."
  },
  {
    "type": "paragraph",
    "text": "Anda mengakui dan menyetujui bahwa Saat Teduh tidak bertanggung jawab atas Layanan Pihak Ketiga mana pun, termasuk akurasi, kelengkapan, ketepatan waktu, validitas, kepatuhan hak cipta, legalitas, kesopanan, kualitas, atau aspek lainnya. Saat Teduh tidak memikul dan tidak akan memiliki tanggung jawab apa pun kepada Anda atau orang maupun entitas lain atas Layanan Pihak Ketiga mana pun."
  },
  {
    "type": "paragraph",
    "text": "Layanan Pihak Ketiga dan tautannya disediakan semata-mata sebagai kemudahan bagi Anda dan Anda mengakses serta menggunakannya sepenuhnya atas risiko Anda sendiri dan tunduk pada syarat serta ketentuan pihak ketiga tersebut."
  },
  {
    "type": "heading",
    "text": "Informasi tentang General Data Protection Regulation (GDPR)"
  },
  {
    "type": "paragraph",
    "text": "Kami mungkin mengumpulkan dan menggunakan informasi dari Anda jika Anda berasal dari European Economic Area (EEA), dan pada bagian Kebijakan Privasi ini kami akan menjelaskan secara tepat bagaimana dan mengapa data ini dikumpulkan, serta bagaimana kami menjaga data ini tetap terlindungi agar tidak direplikasi atau digunakan dengan cara yang salah."
  },
  {
    "type": "heading",
    "text": "Apa itu GDPR?"
  },
  {
    "type": "paragraph",
    "text": "GDPR adalah hukum privasi dan perlindungan data di seluruh Uni Eropa yang mengatur bagaimana data penduduk Uni Eropa dilindungi oleh perusahaan dan meningkatkan kontrol yang dimiliki penduduk Uni Eropa atas data pribadi mereka."
  },
  {
    "type": "paragraph",
    "text": "GDPR relevan bagi setiap perusahaan yang beroperasi secara global dan bukan hanya bisnis berbasis Uni Eropa serta penduduk Uni Eropa. Data pelanggan kami penting terlepas dari di mana mereka berada, itulah sebabnya kami telah menerapkan kontrol GDPR sebagai standar dasar untuk semua operasi kami di seluruh dunia."
  },
  {
    "type": "heading",
    "text": "Apa itu data pribadi?"
  },
  {
    "type": "paragraph",
    "text": "Setiap data yang berkaitan dengan individu yang teridentifikasi atau dapat diidentifikasi. GDPR mencakup spektrum informasi yang luas yang dapat digunakan sendiri, atau dikombinasikan dengan informasi lain, untuk mengidentifikasi seseorang. Data pribadi melampaui nama atau alamat email seseorang. Beberapa contoh termasuk informasi keuangan, pandangan politik, data genetik, data biometrik, alamat IP, alamat fisik, orientasi seksual, dan etnisitas."
  },
  {
    "type": "paragraph",
    "text": "Prinsip Perlindungan Data mencakup persyaratan seperti:"
  },
  {
    "type": "list",
    "items": [
      "Data pribadi yang dikumpulkan harus diproses dengan cara yang adil, sah, dan transparan serta hanya boleh digunakan dengan cara yang secara wajar diharapkan seseorang.",
      "Data pribadi hanya boleh dikumpulkan untuk memenuhi tujuan tertentu dan hanya boleh digunakan untuk tujuan tersebut. Organisasi harus menjelaskan mengapa mereka memerlukan data pribadi ketika mengumpulkannya.",
      "Data pribadi harus disimpan tidak lebih lama dari yang diperlukan untuk memenuhi tujuannya.",
      "Orang yang dicakup oleh GDPR berhak mengakses data pribadi mereka sendiri. Mereka juga dapat meminta salinan data mereka, serta meminta data mereka diperbarui, dihapus, dibatasi, atau dipindahkan ke organisasi lain."
    ]
  },
  {
    "type": "heading",
    "text": "Mengapa GDPR penting?"
  },
  {
    "type": "paragraph",
    "text": "GDPR menambahkan beberapa persyaratan baru mengenai bagaimana perusahaan harus melindungi data pribadi individu yang mereka kumpulkan dan proses. GDPR juga meningkatkan tingkat kepatuhan dengan memperkuat penegakan hukum dan mengenakan denda yang lebih besar atas pelanggaran. Di luar fakta tersebut, ini memang hal yang benar untuk dilakukan. Di Saat Teduh kami sangat percaya bahwa privasi data Anda sangat penting dan kami sudah memiliki praktik keamanan dan privasi yang kuat yang melampaui persyaratan regulasi baru ini."
  },
  {
    "type": "heading",
    "text": "Hak Subjek Data Individu - Akses Data, Portabilitas, dan Penghapusan"
  },
  {
    "type": "paragraph",
    "text": "Kami berkomitmen membantu pelanggan kami memenuhi persyaratan hak subjek data GDPR. Saat Teduh memproses atau menyimpan seluruh data pribadi pada vendor yang telah diverifikasi penuh dan patuh DPA. Kami menyimpan semua percakapan dan data pribadi hingga 6 tahun kecuali akun Anda dihapus. Dalam hal tersebut, kami membuang seluruh data sesuai Ketentuan Layanan dan Kebijakan Privasi kami, namun kami tidak akan menahannya lebih dari 60 hari."
  },
  {
    "type": "paragraph",
    "text": "Kami memahami bahwa jika Anda bekerja dengan pelanggan Uni Eropa, Anda harus dapat memberi mereka kemampuan untuk mengakses, memperbarui, mengambil, dan menghapus data pribadi. Kami mendukung Anda! Kami dibangun sebagai self service sejak awal dan selalu memberi Anda akses ke data Anda dan data pelanggan Anda. Tim dukungan pelanggan kami siap membantu menjawab pertanyaan apa pun yang mungkin Anda miliki tentang penggunaan API."
  },
  {
    "type": "heading",
    "text": "Penduduk California"
  },
  {
    "type": "paragraph",
    "text": "California Consumer Privacy Act (CCPA) mewajibkan kami mengungkap kategori Informasi Pribadi yang kami kumpulkan dan bagaimana kami menggunakannya, kategori sumber dari mana kami mengumpulkan Informasi Pribadi, serta pihak ketiga dengan siapa kami membagikannya, yang telah kami jelaskan di atas."
  },
  {
    "type": "paragraph",
    "text": "Kami juga diwajibkan menyampaikan informasi tentang hak-hak yang dimiliki penduduk California berdasarkan hukum California. Anda dapat menggunakan hak-hak berikut:"
  },
  {
    "type": "list",
    "items": [
      "Hak untuk Mengetahui dan Mengakses. Anda dapat mengajukan permintaan yang dapat diverifikasi terkait informasi mengenai: (1) kategori Informasi Pribadi yang kami kumpulkan, gunakan, atau bagikan; (2) tujuan kategori Informasi Pribadi dikumpulkan atau digunakan oleh kami; (3) kategori sumber dari mana kami mengumpulkan Informasi Pribadi; dan (4) bagian spesifik Informasi Pribadi yang kami kumpulkan tentang Anda.",
      "Hak atas Layanan yang Setara. Kami tidak akan mendiskriminasi Anda jika Anda menggunakan hak privasi Anda.",
      "Hak untuk Menghapus. Anda dapat mengajukan permintaan yang dapat diverifikasi untuk menutup akun Anda dan kami akan menghapus Informasi Pribadi tentang Anda yang telah kami kumpulkan.",
      "Meminta agar bisnis yang menjual data pribadi konsumen tidak menjual data pribadi konsumen tersebut."
    ]
  },
  {
    "type": "paragraph",
    "text": "Jika Anda mengajukan permintaan, kami memiliki waktu satu bulan untuk merespons Anda. Jika Anda ingin menggunakan salah satu hak ini, silakan hubungi kami."
  },
  {
    "type": "paragraph",
    "text": "Kami tidak menjual Informasi Pribadi pengguna kami."
  },
  {
    "type": "paragraph",
    "text": "Untuk informasi lebih lanjut tentang hak-hak ini, silakan hubungi kami."
  },
  {
    "type": "heading",
    "text": "California Online Privacy Protection Act (CalOPPA)"
  },
  {
    "type": "paragraph",
    "text": "CalOPPA mewajibkan kami mengungkap kategori Informasi Pribadi yang kami kumpulkan dan bagaimana kami menggunakannya, kategori sumber dari mana kami mengumpulkan Informasi Pribadi, serta pihak ketiga dengan siapa kami membagikannya, yang telah kami jelaskan di atas."
  },
  {
    "type": "paragraph",
    "text": "Pengguna CalOPPA memiliki hak-hak berikut:"
  },
  {
    "type": "list",
    "items": [
      "Hak untuk Mengetahui dan Mengakses. Anda dapat mengajukan permintaan yang dapat diverifikasi terkait informasi mengenai: (1) kategori Informasi Pribadi yang kami kumpulkan, gunakan, atau bagikan; (2) tujuan kategori Informasi Pribadi dikumpulkan atau digunakan oleh kami; (3) kategori sumber dari mana kami mengumpulkan Informasi Pribadi; dan (4) bagian spesifik Informasi Pribadi yang kami kumpulkan tentang Anda.",
      "Hak atas Layanan yang Setara. Kami tidak akan mendiskriminasi Anda jika Anda menggunakan hak privasi Anda.",
      "Hak untuk Menghapus. Anda dapat mengajukan permintaan yang dapat diverifikasi untuk menutup akun Anda dan kami akan menghapus Informasi Pribadi tentang Anda yang telah kami kumpulkan.",
      "Hak untuk meminta agar bisnis yang menjual data pribadi konsumen tidak menjual data pribadi konsumen tersebut."
    ]
  },
  {
    "type": "paragraph",
    "text": "Jika Anda mengajukan permintaan, kami memiliki waktu satu bulan untuk merespons Anda. Jika Anda ingin menggunakan salah satu hak ini, silakan hubungi kami."
  },
  {
    "type": "paragraph",
    "text": "Kami tidak menjual Informasi Pribadi pengguna kami."
  },
  {
    "type": "paragraph",
    "text": "Untuk informasi lebih lanjut tentang hak-hak ini, silakan hubungi kami."
  },
  {
    "type": "heading",
    "text": "Hubungi Kami"
  },
  {
    "type": "paragraph",
    "text": "Jangan ragu untuk menghubungi kami jika Anda memiliki pertanyaan."
  }
];

export default privacyPolicyBlocksId;
